import React from 'react';
import propTypes from 'prop-types';
import isFinite from 'lodash/fp/isFinite';

import LedgerItem from './LedgerItem';
import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';

const Ledger = props => {
  const savings =
    props.savings > 0 ? (
      <LedgerItem
        label={<TranslatedMessage id="cart.order_summary.savings" />}
        value={
          <>
            -<PriceSpan amount={props.savings} />
          </>
        }
      />
    ) : null;

  const subtotal = (
    <LedgerItem
      label={<TranslatedMessage id="cart.order_summary.subtotal" />}
      value={<PriceSpan cents={props.subtotal} />}
    />
  );

  const shipping = props.showShipping ? (
    <LedgerItem
      label={<TranslatedMessage id="cart.order_summary.shipping" />}
      value={<PriceSpan cents={props.shipping} />}
    />
  ) : null;

  const taxDisplay = isFinite(props.tax) ? (
    <PriceSpan cents={props.tax} />
  ) : (
    <TranslatedMessage id="cart.order_summary.tbd" />
  );

  const tax = props.showTaxes ? (
    <LedgerItem
      label={<TranslatedMessage id="cart.order_summary.tax" />}
      value={taxDisplay}
    />
  ) : null;

  return (
    <>
      <div className="cart-ledger">
        {savings}
        {subtotal}
        {shipping}
        {tax}
      </div>

      <div className="cart-ledger cart-ledger--totals">
        <LedgerItem
          className="cart-ledger__item--total"
          label={<TranslatedMessage id="cart.sidebar.total" />}
          textStyle="heading--medium"
          value={<PriceSpan cents={props.total} />}
        />
        {!!props.checkoutButton && props.checkoutButton}
      </div>
    </>
  );
};

Ledger.propTypes = {
  checkoutButton: propTypes.element,
  savings: propTypes.number.isRequired,
  shipping: propTypes.number.isRequired,
  showTaxes: propTypes.bool,
  showShipping: propTypes.bool,
  subtotal: propTypes.number.isRequired,
  tax: propTypes.number,
  total: propTypes.number.isRequired,
};

export default Ledger;
